export default "__VITE_ASSET__DNMHAFx___"